import { SolutionKeyParams } from "pages/RoutesTyping";
import { ReactNode } from "react";
import { useParams } from "react-router";
import { SolutionKeyContext } from "./SolutionKeyContext";

interface SolutionKeyProviderProps {
  children: ReactNode;
}

const SolutionKeyProvider = ({ children }: SolutionKeyProviderProps) => {
  const { solutionKey } = useParams<SolutionKeyParams>();

  return (
    <SolutionKeyContext.Provider value={solutionKey}>
      {children}
    </SolutionKeyContext.Provider>
  );
};
export default SolutionKeyProvider;
